export const ERROR_DELETING = 'ERROR_DELETING';
export const ERROR_LOADING = 'ERROR_LOADING';
export const ERROR_SAVING = 'ERROR_SAVING';
export const SUCCESS_DELETE = 'SUCCESS_DELETE';
export const SUCCESS_SAVE = 'SUCCESS_SAVE';
export const WARNING_EVENT = 'WARNING_EVENT';
export const DOC_CREATED = 'DOC_CREATED';
export const DOC_UPDATED = 'DOC_UPDATED';
